import { Package } from "lucide-react";
import { CARGO_ROWS, CARGO_COLS, bagHex, slotLabel, plural } from "./cargoSlots";

const FIXED_ORDER = ["cab", ...CARGO_ROWS.flatMap(([r]) => CARGO_COLS.map(([c]) => `${r}-${c}`)), "side"];
const STATUS = { done: "Doręczona", skipped: "Niedoręczona" };

const groupStops = (stops) => {
  const map = new Map();
  stops.filter((s) => !s.is_fixed).forEach((s) => {
    const key = s.cargo_slot || "";
    if (!map.has(key)) map.set(key, { key, bag: s.cargo_bag, stops: [] });
    map.get(key).stops.push(s);
  });
  const rank = (g) => (!g.key ? 10000 : g.key.startsWith("bag:") ? 100 + (g.bag?.number || 0) : FIXED_ORDER.indexOf(g.key));
  return [...map.values()].sort((a, b) => rank(a) - rank(b)).map((g) => ({ ...g, stops: g.stops.sort((a, b) => a.final_order - b.final_order) }));
};

export const CargoGroups = ({ stops, dark = false }) => {
  const groups = groupStops(stops);
  const card = dark ? "bg-white/5" : "bg-white ring-1 ring-zinc-200";
  const muted = dark ? "text-zinc-400" : "text-zinc-500";
  return (
    <div data-testid="cargo-groups" className="stagger space-y-3">
      {groups.map((g) => (
        <section key={g.key || "none"} data-testid={`cargo-group-${g.key || "none"}`} className={`rounded-xl p-3 ${card}`}>
          <header className="flex items-center gap-2 mb-2">
            {g.bag ? <span className="w-3.5 h-3.5 rounded-full ring-1 ring-black/20" style={{ background: bagHex(g.bag) }} /> : <Package className={`w-4 h-4 ${g.key ? "text-orange-500" : muted}`} />}
            <h3 className="font-heading font-black text-sm uppercase tracking-wide mr-auto">{g.key ? slotLabel(g.key, g.bag) : "Bez miejsca"}</h3>
            <span className={`text-[11px] font-mono ${muted}`}>{plural(g.stops.length, "paczka", "paczki", "paczek")}</span>
          </header>
          <ol className="space-y-1">
            {g.stops.map((s) => (
              <li key={`${s.final_order}-${s.address_text}`} data-testid={`cargo-group-stop-${s.final_order}`} className={`flex items-center gap-3 text-sm ${s.status && s.status !== "pending" ? "opacity-50 line-through" : ""}`}>
                <span className="w-8 font-mono font-black text-orange-500">{s.final_order}</span>
                <span className="min-w-0 flex-1 truncate font-semibold">{s.address_text}</span>
                {s.parcel_number && <span className={`font-mono text-[11px] ${muted}`}>#{s.parcel_number}</span>}
                {STATUS[s.status] && <span className="sr-only">{STATUS[s.status]}</span>}
              </li>
            ))}
          </ol>
        </section>
      ))}
    </div>
  );
};
